/**
 * /billing/mrr — cross-tenant MRR rollup (Phase 6 Plan 07, PLATBILL-05).
 *
 * Replaces the Plan 06-05 placeholder; D-09 mandates a single Stat card with
 * NO chart for v1.0. Real screen lives in `features/billing/MrrStatScreen.tsx`.
 */
import { createFileRoute } from "@tanstack/react-router";
import { MrrStatScreen } from "../features/billing/MrrStatScreen";

export const Route = createFileRoute("/_auth/billing/mrr")({
  staticData: {
    breadcrumb: { labelKey: "link-admin:billing.hub.tabs.mrr" },
  },
  component: MrrStatScreen,
});
